import React from 'react';
import { Container, Row, Col, Badge } from 'react-bootstrap';
import { motion } from 'framer-motion';
import { FaBook, FaClock, FaBlogger } from 'react-icons/fa';

const Blog = ({ currentTheme }) => {
  const fadeInUp = {
    initial: { opacity: 0, y: 30 },
    whileInView: { opacity: 1, y: 0 },
    viewport: { once: true },
    transition: { duration: 0.6 }
  };

  const blogPosts = [
    {
      title: "Emerging Trends in Software Development",
      desc: "Exploring the latest advancements and innovations in the software development landscape.",
      link: "https://elyssaembler23.blogspot.com/2025/01/emerging-trends-in-software-development.html",
      readTime: "3 min read",
      date: "Jan 25, 2025"
    },
    {
      title: "The Future of Data Science",
      desc: "Delving into the evolving role of data science in business and technology.",
      link: "https://elyssaembler23.blogspot.com/2025/01/the-future-of-data-science.html",
      readTime: "4 min read",
      date: "Jan 24, 2025"
    },
    {
      title: "UI/UX Design Principles for Enhanced User Experience",
      desc: "Discussing key principles for creating user-friendly and visually appealing interfaces.",
      link: "https://elyssaembler23.blogspot.com/2025/01/uiux-design-principles-for-enhanced.html",
      readTime: "5 min read",
      date: "Jan 23, 2025"
    },
    {
      title: "Advancements in Artificial Intelligence",
      desc: "Examining recent breakthroughs and applications of AI in various industries.",
      link: "https://elyssaembler23.blogspot.com/2025/01/advancements-in-artificial-intelligence.html",
      readTime: "3 min read",
      date: "Jan 22, 2025"
    }
  ];

  return (
    <Container fluid className="py-5 position-relative overflow-hidden" id='blog' style={{ backgroundColor: currentTheme.background }}>
      <div className="position-absolute w-100 h-100 top-0 start-0" style={{ zIndex: -1 }}>
        <motion.div
          animate={{
            background: [
              `linear-gradient(45deg, ${currentTheme.primary} 0%, ${currentTheme.secondary} 100%)`,
              `linear-gradient(45deg, ${currentTheme.secondary} 0%, ${currentTheme.primary} 100%)`
            ],
          }}
          transition={{ duration: 3, repeat: Infinity, repeatType: 'reverse' }}
          className="w-100 h-100"
        />
      </div>

      <Container className="position-relative">
        <motion.div
          className="text-center mb-5"
          initial={{ opacity: 0, y: -20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
        >
          <motion.div
            animate={{
              y: [-5, 5, -5],
              transition: { duration: 2, repeat: Infinity }
            }}
            className="mb-3"
          >
            <FaBook style={{ color: currentTheme.primary }} className="display-1" />
          </motion.div>
          <h2 className="display-4 fw-bold mb-1" style={{ color: currentTheme.primary }}>BLOG</h2>
          <div className="d-flex align-items-center justify-content-center gap-2 mb-4">
            <div style={{ backgroundColor: currentTheme.primary, height: '2px', width: '30px' }}></div>
            <FaBook style={{ color: currentTheme.primary }} />
            <div style={{ backgroundColor: currentTheme.primary, height: '2px', width: '30px' }}></div>
          </div>
        </motion.div>

        <Row className="row-cols-1 row-cols-md-2 g-4">
          {blogPosts.map((post, index) => (
            <Col key={index}>
              <motion.div
                {...fadeInUp}
                className="p-4 rounded shadow-sm h-100 d-flex flex-column"
                style={{ 
                  backgroundColor: currentTheme.background === '#121212' ? '#222222' : 'rgba(255, 255, 255, 0.9)',
                  borderColor: currentTheme.primary,
                  borderWidth: '1px',
                  borderStyle: 'solid'
                }}
              >
                <div className="mb-3">
                  <Badge bg="primary" style={{ backgroundColor: currentTheme.primary, color: currentTheme.background }}>
                    {post.date}
                  </Badge>
                  <h5 className="fw-bold mb-2" style={{ color: currentTheme.text }}>{post.title}</h5>
                  <p className="mb-3" style={{ color: currentTheme.text }}>{post.desc}</p>
                </div>
                <div className="mt-auto d-flex justify-content-between align-items-center">
                  <div className="d-flex align-items-center">
                    <FaClock style={{ color: currentTheme.primary }} className="me-2" />
                    <small style={{ color: currentTheme.text }}>{post.readTime}</small>
                  </div>
                  <a href={post.link} target="_blank" rel="noopener noreferrer" className="btn" style={{ 
                    color: currentTheme.background, 
                    backgroundColor: currentTheme.secondary,
                    borderColor: currentTheme.secondary
                  }}>
                    Read <FaBlogger className="ms-2" />
                  </a>
                </div>
              </motion.div>
            </Col>
          ))}
        </Row>

        <motion.div
          animate={{
            rotate: 360,
            transition: { duration: 20, repeat: Infinity, ease: "linear" }
          }}
          className="position-absolute"
          style={{ top: '10%', right: '5%', opacity: 0.1 }}
        >
          <FaBook style={{ fontSize: '4rem', color: currentTheme.primary }} />
        </motion.div>
      </Container>
    </Container>
  );
};

export default Blog;